// Simple localStorage cache with TTL for offline fallback.
// Keys prefixed with "zc:" to avoid collisions.

const PREFIX = 'zc:'

export function cacheGet(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (!raw) return null
    const { data, ts, ttl } = JSON.parse(raw)
    if (ttl && Date.now() - ts > ttl) {
      localStorage.removeItem(PREFIX + key)
      return null
    }
    return data
  } catch {
    return null
  }
}

export function cacheSet(key, data, ttlMs) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ data, ts: Date.now(), ttl: ttlMs }))
  } catch {
    // localStorage quota exceeded — ignore
  }
}

// Сбросить кэш дневника для будущих дат. Дни, кроме сегодняшнего, кэшируются
// на 24 часа, и «завтра», просмотренное до дублирования, показывало бы утром
// вчерашний (пустой) снимок до прихода сети. После создания/удаления копий
// на будущих датах этот кэш заведомо неверен.
export function cacheClearFutureDiary(todayStr) {
  try {
    const p = PREFIX + 'diary:'
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i)
      if (!k || !k.startsWith(p)) continue
      // Сегодня — тоже: копия «на сегодня» у блюда из прошлого ложится в
      // сегодняшний день, а его снимок живёт 10 минут
      if (k.slice(p.length) >= todayStr) localStorage.removeItem(k)
    }
  } catch {
    // ignore
  }
}

export function cacheDel(key) {
  try { localStorage.removeItem(PREFIX + key) } catch { /* ignore */ }
}

// Remove all cache entries older than maxAgeMs (default 90 days)
export function cacheClean(maxAgeMs = 90 * 24 * 3600 * 1000) {
  try {
    const now = Date.now()
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i)
      if (!k || !k.startsWith(PREFIX)) continue
      try {
        const { ts } = JSON.parse(localStorage.getItem(k))
        if (now - ts > maxAgeMs) localStorage.removeItem(k)
      } catch {
        localStorage.removeItem(k)
      }
    }
  } catch {
    // ignore
  }
}
